export type LoadingManagerCallback = () => void;

export class LoadingManager {
  private pendingCount = 0;

  private onStartCallbacks = [] as LoadingManagerCallback[];
  private onCompleteCallbacks = [] as LoadingManagerCallback[];

  register(promise: Promise<unknown>) {
    if (this.pendingCount <= 0) {
      this.start();
    }

    this.pendingCount++;

    promise
      .finally(() => {
        this.pendingCount--;

        if (this.pendingCount <= 0) {
          this.complete();
        }
      })
      // `.finally()` returns a new promise that inherits rejection. Nobody awaits
      // it; callers already await `promise`. Without this catch, expected AbortErrors
      // (mapStateMachine cancelling preload so viewport tiles go first) surface as
      // unhandled rejections. Real request errors are still thrown from the awaited
      // `promise`.
      .catch(() => {});
  }

  onStart(callback: LoadingManagerCallback) {
    this.onStartCallbacks.push(callback);
  }

  onComplete(callback: LoadingManagerCallback) {
    this.onCompleteCallbacks.push(callback);
  }

  private start() {
    this.onStartCallbacks.forEach((callback) => callback());
  }

  private complete() {
    this.onCompleteCallbacks.forEach((callback) => callback());
  }
}

export default LoadingManager;
